import { AxiosResponse } from 'axios';
import ApiConstants from '../../../../core/constants/api_constants';
import { request } from '../../../../core/network/axiosInstance';
import { CertificateInterface } from '../../domain/interface/certificate_interface';

export class CertificateApiService {
  private readonly certifBaseUrl: string;

  constructor() {
    this.certifBaseUrl = ApiConstants().certif;
  }

  async getCertificateByThemeId(themeId: string): Promise<AxiosResponse<CertificateInterface>> {
    const response = await request<CertificateInterface>({
      method: 'GET',
      url: `${this.certifBaseUrl}theme/${themeId}`,
      requiresToken: true,
    });
    return response;
  }
}
